module.exports = __webpack_public_path__ + "media/manage/notice-only-fa4b9cc5.png";